import dayjs from 'dayjs';

export const formatDateFromYYYYMMDD = (dateString: string): string => {
  return dayjs(dateString).format('MMM D, YYYY');
}